/*
 * DE — Search scope checkboxes
 * ------------------------------------------------------------------
 * Adds 3-way scope filtering (Works / Journal & News / Legacy Collection)
 * to both the header search modal and the /search template form.
 *
 * Scope → Shopify search params mapping:
 *   works   → type=product            (regular products, NOT Legacy vendor)
 *   journal → type=article            (blog articles)
 *   legacy  → type=product + q appended with vendor:"The Legacy Collection"
 *
 * Works + Legacy together just submits type=product (covers both supersets).
 * When only Works is checked we append `-vendor:"The Legacy Collection"`
 * to q so Legacy products are excluded from the Works-only view.
 *
 * Scope state is round-tripped via a `scope` URL param so checkbox state
 * restores correctly on the results page.
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  var LEGACY_VENDOR = 'The Legacy Collection';

  function getScopeFromForm(form) {
    var boxes = form.querySelectorAll('[data-search-scope-input]');
    var scopes = [];
    boxes.forEach(function (b) {
      if (b.checked) scopes.push(b.value);
    });
    return scopes;
  }

  function setScopeOnForm(form, scopes) {
    var boxes = form.querySelectorAll('[data-search-scope-input]');
    boxes.forEach(function (b) {
      b.checked = scopes.indexOf(b.value) !== -1;
    });
  }

  function prefillFromUrl(form) {
    var params = new URLSearchParams(window.location.search);
    var scopeParam = params.get('scope');

    if (!scopeParam) {
      // No scope in URL → default all checked (matches legacy "search everything")
      setScopeOnForm(form, ['works', 'journal', 'legacy']);
      return;
    }

    var scopes = scopeParam.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    setScopeOnForm(form, scopes);
  }

  function buildSearchUrl(queryRaw, scopes) {
    var query = (queryRaw || '').trim();
    var params = new URLSearchParams();

    // If nothing selected, treat as search-all so the user always gets results.
    var effectiveScopes = scopes.length ? scopes.slice() : ['works', 'journal', 'legacy'];

    var wantsWorks   = effectiveScopes.indexOf('works')   !== -1;
    var wantsJournal = effectiveScopes.indexOf('journal') !== -1;
    var wantsLegacy  = effectiveScopes.indexOf('legacy')  !== -1;

    // Compose the q parameter — append Shopify search field filters as needed.
    var qFinal = query;

    if (wantsLegacy && !wantsWorks) {
      // Only Legacy (and maybe Journal) — restrict products to Legacy vendor
      qFinal = query + ' vendor:"' + LEGACY_VENDOR + '"';
    } else if (wantsWorks && !wantsLegacy) {
      // Only Works (and maybe Journal) — exclude Legacy vendor from products
      qFinal = query + ' -vendor:"' + LEGACY_VENDOR + '"';
    }
    // If both Works and Legacy are checked, no vendor filter needed.

    params.set('q', qFinal);
    params.set('options[prefix]', 'last');

    // Compose the type parameter
    var types = [];
    if (wantsWorks || wantsLegacy) types.push('product');
    if (wantsJournal)              types.push('article');
    if (types.length && types.length < 3) {
      params.set('type', types.join(','));
    }

    // Round-trip scope state for the results page
    params.set('scope', effectiveScopes.join(','));

    return '/search?' + params.toString();
  }

  function attachForm(form) {
    if (!form || form.__deScopeBound) return;
    form.__deScopeBound = true;

    prefillFromUrl(form);

    form.addEventListener('submit', function (e) {
      var qInput = form.querySelector('input[name="q"]');
      var query = qInput ? qInput.value : '';
      var scopes = getScopeFromForm(form);

      // Let empty queries fall through to Shopify's default behaviour
      if (!query.trim()) return;

      e.preventDefault();
      window.location.href = buildSearchUrl(query, scopes);
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-search-scope-form]');
    forms.forEach(attachForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on dynamic insertion (e.g. modal open re-renders)
  document.addEventListener('shopify:section:load', init);
})();
